<template>
  <div class="container card-container">
    <!-- NOTE: 言語設定 -->
    <div class="form-row">
      <div class="col">
        <div class="form-group">
          <label for="select-language">
            {{ $t("SmartScheduling.Personal.Label.SelectLanguage") }}
          </label>
          <VSelectbox
            :items="langItems"
            select-id="select-language"
            size="sm"
            block
            @selectedData="editData.userLang = $event"
            :placeholder="$t('SmartScheduling.Common.Data.Language')"
          />
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="select-language">
            {{ $t("SmartScheduling.Personal.Label.RoomLocation") }}
          </label>
          <VSelectbox
            :items="roomList"
            select-id="select-language"
            size="sm"
            block
            @selectedData="editData.selectedLocation = $event"
            :placeholder="$t('SmartScheduling.Personal.Label.SelectRoomLocation')"
          >
            <template
              v-if="!roomList.length"
              #error
            >
              {{ $t("SmartScheduling.Personal.Label.NoRoomLocation") }}
            </template>
          </VSelectbox>
        </div>
      </div>
    </div>

    <!-- NOTE: 登録許可語句設定 -->
    <div class="card md-12">
      <div class="card-body">
        <h5 class="card-title">
          {{ $t("SmartScheduling.Personal.Label.ExclusionWords") }}
        </h5>
        <p class="card-description">
          {{ $t("SmartScheduling.Personal.Label.ExclusionWordsDetail") }}
        </p>
        <div class="card-text">
          <div class="form-row">
            <div class="col-md-2 align-self-center">
              <label class="sub-label">
                {{ $t("SmartScheduling.Personal.Label.AllDay") }}
              </label>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="all-day-empty-personal">
                  {{ $t("SmartScheduling.Personal.Label.Empty") }}
                </label>
                <small class="form-text">
                  {{ $t("SmartScheduling.Personal.Label.EmptyDetail") }}
                </small>
                <input
                  type="text"
                  id="all-day-empty-personal"
                  v-model="editData.dayPlanOk"
                  class="form-control form-control-sm"
                  :placeholder="$t('SmartScheduling.Personal.Label.EmptyPlaceholder')"
                >
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="all-day-planned-personal">
                  {{ $t("SmartScheduling.Personal.Label.Planned") }}
                </label>
                <small class="form-text">
                  {{ $t("SmartScheduling.Personal.Label.PlannedDetail") }}
                </small>
                <input
                  type="text"
                  id="all-day-planned-personal"
                  v-model="editData.dayPlanNg"
                  class="form-control form-control-sm"
                  :placeholder="$t('SmartScheduling.Personal.Label.PlannedPlaceholder')"
                >
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-2 align-self-center">
              <label class="sub-label">
                {{ $t("SmartScheduling.Personal.Label.SpecificTime") }}
              </label>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="pecific-time-empty-personal">
                  {{ $t("SmartScheduling.Personal.Label.Empty") }}
                </label>
                <small class="form-text">
                  {{ $t("SmartScheduling.Personal.Label.EmptyDetail") }}
                </small>
                <input
                  type="text"
                  id="pecific-time-empty-personal"
                  v-model="editData.timePlanOk"
                  class="form-control form-control-sm"
                  :placeholder="$t('SmartScheduling.Personal.Label.EmptyPlaceholder')"
                >
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="pecific-time-planned-personal">
                  {{ $t("SmartScheduling.Personal.Label.Planned") }}
                </label>
                <small class="form-text">
                  {{ $t("SmartScheduling.Personal.Label.PlannedDetail") }}
                </small>
                <input
                  type="text"
                  id="pecific-time-planned-personal"
                  v-model="editData.timePlanNg"
                  class="form-control form-control-sm"
                  :placeholder="$t('SmartScheduling.Personal.Label.PlannedPlaceholder')"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- NOTE: Calendar代理アクセス -->
    <div class="card md-12">
      <div class="card-body">
        <h5 class="card-title">
          {{ $t("SmartScheduling.Personal.Label.CalendarProxyAccess") }}
        </h5>
        <p class="card-description">
          {{ $t("SmartScheduling.Personal.Label.CalendarProxyAccessDetail") }}
        </p>
        <div class="card-text">
          <div class="form-row">
            <div class="col">
              <div class="form-group">
                <label for="calendar-proxy-access-allow">
                  {{ $t("SmartScheduling.Personal.Label.CalendarProxyAccessAllow") }}
                </label>
                <small class="form-text">
                  {{ $t("SmartScheduling.Personal.Label.CalendarProxyAccessAllowDetail") }}
                </small>
                <input
                  type="text"
                  id="calendar-proxy-access-allow"
                  v-model="editData.sharingAdjustmentOk"
                  class="form-control form-control-sm"
                  :placeholder="$t('SmartScheduling.Personal.Label.CalendarProxyAccessAllowPlaceholder')"
                >
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="calendar-proxy-access-deny">
                  {{ $t("SmartScheduling.Personal.Label.CalendarProxyAccessDeny") }}
                </label>
                <small class="form-text">
                  {{ $t("SmartScheduling.Personal.Label.CalendarProxyAccessDenyDetail") }}
                </small>
                <input
                  type="text"
                  id="calendar-proxy-access-deny"
                  v-model="editData.sharingAdjustmentNg"
                  class="form-control form-control-sm"
                  :placeholder="$t('SmartScheduling.Personal.Label.CalendarProxyAccessDenyPlaceholder')"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VSelectbox from '../../VSelectbox.vue'

export default {
  components: {
    VSelectbox,
  },
  props: {
    personalSettingData: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    editData: {}
  }),
  computed: {
    langItems() {
      const lang = this.editData.userLang
      return [
        { text: '日本語', value: 'ja', selected: lang === 'ja' },
        { text: 'English', value: 'en', selected: lang === 'en' }
      ]
    },
    roomList() {
      if (!Array.isArray(this.editData.availableLocations)) return []
      return this.editData.availableLocations.map((d) => ({
        text: d,
        value: d,
        selected: d === this.editData.selectedLocation
      }))
    }
  },
  watch: {
    personalSettingData: {
      handler: function(v, _) {
        this.editData = Object.assign({}, v)
      },
      deep: true
    },
    editData: {
      handler: function(v, old) {
        this.updateEditData(v, old)
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    updateEditData(v, old) {
      if (!Object.keys(old).length) return {}
      this.$emit('updateEditData',  v)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  .card + .card {
    margin-top: 12px;
  }
}
</style>
